import { SuggestionsCategory } from '@/models/chat.models';
import { KeyPointResponse } from '@/models/doc-review';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useReviewingStore = defineStore('reviewingStore', () => {
  const suggestions = ref<SuggestionsCategory[]>([]);
  const keyPointsResponse = ref<KeyPointResponse>({
    keyPoints: [],
    conclusion: ''
  });

  function setSuggestions(newSuggestions: SuggestionsCategory[]) {
    suggestions.value = newSuggestions;
  }

  function setKeypointsResponse(newKeypoints: KeyPointResponse) {
    keyPointsResponse.value = newKeypoints;
  }

  return {
    suggestions,
    setSuggestions,
    keyPointsResponse,
    setKeypointsResponse
  };
});
